var exports = {
  "N": "xa15a2ab7--7a0924--element",
};

module.exports = exports;
